module.exports = __webpack_public_path__ + "/images/logo-af-babyone.d8507e5.webp";